var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIt01 = function SvgAlertIt01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_it-01_svg2__a",
    x1: 15.11,
    x2: 171.82,
    y1: 180.09,
    y2: 30.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_it-01_svg2__a",
    id: "alert_it-01_svg2__b",
    x1: 42.7,
    x2: 199.41,
    y1: 208.93,
    y2: 59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_it-01_svg2__a",
    id: "alert_it-01_svg2__c",
    x1: 11.66,
    x2: 168.36,
    y1: 176.48,
    y2: 26.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_it-01_svg2__a",
    id: "alert_it-01_svg2__d",
    x1: -8.57,
    x2: 148.14,
    y1: 155.34,
    y2: 5.41
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M187.06 28.56H123.1L110.29 6.38c-2.15-3.72-6-5.95-10.3-5.95s-8.15 2.22-10.3 5.95l-2.84 4.92a2.505 2.505 0 0 0 4.34 2.5l2.84-4.92c1.25-2.16 3.48-3.45 5.97-3.45s4.72 1.29 5.97 3.45l52.67 91.23a6.8 6.8 0 0 1 0 6.89c-1.25 2.16-3.48 3.45-5.97 3.45H47.33c-2.49 0-4.72-1.29-5.97-3.45a6.8 6.8 0 0 1 0-6.89l43.09-74.63a2.505 2.505 0 0 0-4.34-2.5l-3.22 5.58H12.94C6.11 28.56.55 34.12.55 40.95v115.83c0 6.83 5.56 12.39 12.39 12.39h65.58c-.17 5.5-.75 18.56-2.49 25.38H65.54a2.5 2.5 0 0 0 0 5h68.92a2.5 2.5 0 0 0 0-5h-10.49c-1.73-6.82-2.31-19.89-2.49-25.38h65.58c6.83 0 12.39-5.56 12.39-12.39V40.96c0-6.83-5.56-12.39-12.39-12.39Zm0 5c4.08 0 7.39 3.32 7.39 7.39v98.08h-7.21v-90.2c0-3.76-3.06-6.83-6.83-6.83h-49.55l-4.87-8.44zm-174.12 0h61.07L69.14 42H19.58c-3.76 0-6.83 3.06-6.83 6.83v90.21H5.54V40.96c0-4.08 3.32-7.39 7.39-7.39Zm105.9 161H81.16c1.67-7.72 2.21-20.12 2.36-25.38h32.95c.16 5.26.7 17.67 2.36 25.38Zm75.62-37.77c0 4.08-3.32 7.39-7.39 7.39H12.94c-4.08 0-7.39-3.32-7.39-7.39v-12.75h126.6a2.5 2.5 0 0 0 0-5H17.76V48.83c0-1.01.82-1.83 1.83-1.83h46.67L37.04 97.61c-2.15 3.72-2.15 8.17 0 11.89s6 5.95 10.3 5.95h105.34c4.3 0 8.15-2.22 10.3-5.95 2.15-3.72 2.15-8.17 0-11.89L133.76 47h46.67c1.01 0 1.83.82 1.83 1.83v90.21h-36.08a2.5 2.5 0 0 0 0 5h48.29v12.75Z",
    style: {
      fill: "url(#alert_it-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 151.61H93.33a2.5 2.5 0 0 0 0 5h13.34a2.5 2.5 0 0 0 0-5",
    style: {
      fill: "url(#alert_it-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 101.7c5.37 0 9.74-4.37 9.74-9.74s-4.37-9.74-9.74-9.74-9.74 4.37-9.74 9.74 4.37 9.74 9.74 9.74m0-14.49c2.62 0 4.74 2.13 4.74 4.74s-2.13 4.74-4.74 4.74-4.74-2.13-4.74-4.74 2.13-4.74 4.74-4.74",
    style: {
      fill: "url(#alert_it-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06 76.34c5.03 0 9.12-4.09 9.12-9.12V35.59c0-5.03-4.09-9.12-9.12-9.12s-9.12 4.09-9.12 9.12v31.63c0 5.03 4.09 9.12 9.12 9.12m-4.12-40.75c0-2.27 1.85-4.12 4.12-4.12s4.12 1.85 4.12 4.12v31.63c0 2.27-1.85 4.12-4.12 4.12s-4.12-1.85-4.12-4.12z",
    style: {
      fill: "url(#alert_it-01_svg2__d)"
    }
  }));
};
export default SvgAlertIt01;